/**
 * Alt text for the images questionnaire questions carry (Question.imageUrl). The image is content —
 * the pain scale's bands are what the patient is choosing between — so it gets a real description
 * rather than alt="". Keyed by path because the question definitions (TH.Questionnaire, Gen-2 tables)
 * carry only the URL.
 */
const ALT_BY_IMAGE: Record<string, string> = {
  "/images/pain-scale.svg":
    "Pain scale from 0 to 10: 0 no pain, 1 to 3 mild, 4 to 6 moderate, 7 to 9 severe, 10 very severe.",
};

export const questionImageAlt = (imageUrl: string) => ALT_BY_IMAGE[imageUrl] ?? "";
